import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { Reload16 } from '@cian/ui-kit/prev';
import { pluralize } from '@cian/newbuilding-utils';

interface IShowMoreButtonProps {
  onClick: () => void;
  length: number;
}

export function ShowMoreButton({ onClick, length }: IShowMoreButtonProps) {
  return (
    <Button theme="stroke_primary" size="XS" beforeIcon={<Reload16 color="primary_100" />} onClick={onClick}>
      {`Показать еще ${pluralize(length, ['объект', 'объекта', 'объектов'])}`}
    </Button>
  );
}
